var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern20)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern20",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_70_784",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_70_784",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAAsSAAALEgHS3X78AAADZElEQVR42u3dPWgTcRjH8X9FtNDVRBx0EARHJ0FBQXoWFyGK+AY2p0MdREEXFwcNCKKDRVw1aZBCsUVXFQTrIi4J6iYF0UFQbBwkQWzV3+G1FFOkmHtLnu8D36nQXu/5JL3Sa+LckvH8Sk5dUXXVUr+oJ2qGOy2pvFtu9IGCanCyer5gxweXW/4cJ8dM84sIwqd9Hvk2nwnyLvyZzwmxWSkAUONEmK3uuNo3XSsA8JMTYTcAAAAAAOBEAIAAQAAgABAACAAEAAIAAYD+ux/qjbqvrqvz6qQ6pg6ro+q4KqoRdVZdDG/buqnuqEn1VL1Wn+LYFQCibUbdUJ7nlwdcxLPXr6zV534PgGwV3Eo3oXbtKVb6XMyjr/MOANnpgdrqEhwAZKOPar9LYQCQftNqvUtpAJBuwRX9GpfiACC9pgb96mqX8gAgnV6ofpeBAUDyzaqNLiMDgOQbdhkaACR+xV/uA4DddrqMDQCS65nL4AAguY4AwG5fPX+sHwB2G3cZHQAkUxEAttsc8xI3qEPqkrqt7qryCqqobwCIty/ecDWuxe9QT8LX6OGewIz2PKbln/My+EJcAGivEsPy92X1PAOgvatRLn/oRDU4x6+4Lbx7uhDxo38b/xfQXY1EDOAMALorP2IAowAw/Pd/fb57ALANYBIAtgFMAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDIeqQ2ddhAxADWRXBMC40D4N89dD08+v4eA8A2gLcAMApg0K+s0vf3HQBGAQQvU8NFoG0AuwFgG0ARALYBXAaAbQBjALANYBoAtgF8AIBRAN6fdwqZB4BdAFv4Y5BtAEMAsA3gNABsA7gGANsAJgBgG8BLANgG8BkAK2smfEWOTtoe8fJOdXg8t7gnkJtCAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFg8AAgABAACAAAAAAAAAAAAAAAAACwAaLJ0swBawQHWWLpZAPXY3pAQAF0BoBQcYE7NsnhzABoqv3CQBTXH8s0ACHZ94O8DLfBMYAJAo235Sw42F14T1Az/dtCLAJrhTkuLT/vh/AZIWhNIbqXusAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookApi);
export default __webpack_public_path__ + "static/media/facebook-api.e647d53f7b8f88e978176211dfb72537.svg";
export { ForwardRef as ReactComponent };